<template>
  <div class="">
    <el-drawer
      :size="size"
      :visible.sync="digStatus"
      direction="rtl"
      :before-close="handleClose"
    >
      <div class="headerLisk">
        {{ title }}
        <span class="rightAbsulute" @click="handleClose" finger>
          <i class="el-icon-error"></i>
          关闭</span
        >
      </div>
      <div
        class="zg-drawer-body"
        :class="{ overflow: scroll, relative: relative }"
        :style="paddings"
      >
        <slot name="body"></slot>
      </div>
    </el-drawer>
  </div>
</template>

<script>
export default {
  name: "",
  props: {
    // 弹框开关
    visible: {
      type: Boolean,
      default: false,
    },
    // 弹框标题
    title: {
      type: String,
      default: "详情",
    },

    // 弹框宽度
    size: {
      type: String,
      default: "calc(100vw - 202px);min-width: 1100px;",
    },
    paddings: {
      type: String,
      default: "padding: 40px;",
    },
    // 是否可滑动
    scroll: {
      type: Boolean,
      default: false,
    },
    // 是否相对定位
    relative: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    digStatus: {
      get() {
        return this.visible;
      },
      set(value) {
        this.$emit("update:visible", value);
      },
    },
  },
  data() {
    return {};
  },
  methods: {
    handleClose() {
      this.digStatus = false;
      this.$emit("handleClose");
    },
  },
};
</script>

<style lang="less" scoped>
/deep/#el-drawer__title {
  display: none;
}
.headerLisk {
  padding: 0 20px;
  font-weight: 400;
  line-height: 16px;
  color: #333333;
  background: #f7f7f7ff;
  border-bottom: 1px solid @borderColor_base;
  height: 60px;
  position: relative;
  .rightAbsulute {
    i {
      color: #999999;
    }
    &:hover {
      i {
        color: @primaryColor;
      }
    }
    font-size: 14px;
    color: #333333;
    font-weight: 500;
    position: absolute;
    right: 20px;
    top: 50%;
    transform: translateY(-50%);
  }
  &::after {
    content: "";
    display: inline-block;
    height: 100%;
    vertical-align: middle;
  }
}
.zg-drawer-body {
  padding: 40px;
  height: calc(100vh - 80px);
}
.overflow {
  overflow-y: auto;
  box-sizing: border-box;
}
.fixed {
  position: relative;
}

/* 隐藏滚动条 */
.element::-webkit-scrollbar {
  display: none;
}

/* 在需要时显示滚动条 */
.element.show-scrollbar::-webkit-scrollbar {
  display: block;
}
/* 滚动条样式 */
::-webkit-scrollbar {
  width: 5px; /*  设置纵轴（y轴）轴滚动条 */
  height: 4px; /*  设置横轴（x轴）轴滚动条 */
}
/* 滚动条滑块（里面小方块） */
::-webkit-scrollbar-thumb {
  border-radius: 10px;
  box-shadow: inset 0 0 5px #c1c1c1;
  background: #c1c1c1;
}
/* 滚动条轨道 */
::-webkit-scrollbar-track {
  border-radius: 0;
  box-shadow: inset 0 0 5px #c1c1c1;
  background: #c1c1c1;
}
</style>
